import {Buyer, DeliveryLocationStatus, MostRecentAddress} from './common';

import {BagsHistory} from '../../AboutShift/types';
import {DeliveryNotes} from './orderDetails';

/* eslint-disable no-shadow */
export enum DriverOrdersTab {
  RunOrders = 'RunOrders',
  AllOrders = 'AllOrders',
}

export interface OrdersForDelivery {
  buyer: Buyer;
  deliveryInstruction: string;
  deliveryLocation: DeliveryLocation;
  id: number;
  externalId: string;
  run: RunInfo;
}

export interface DeliveryLocation {
  deliveryStatus: DeliveryLocationStatus;
  id: number;
  userAddress: MostRecentAddress;
  onfleetTaskId: string;
  deliveryNote?: DeliveryNotes;
}

export interface RunInfo {
  id: number;
  lat: number;
  lon: number;
  store: StoreData;
}

export interface SubmitDeliveryBagsCountResponse {
  submitDeliveryBagsCount: BagsHistory[];
}

export interface UserPhoneNumber {
  user: number;
  phoneNumber: string;
}

export interface StoreData {
  id: number;
  storeLogoUrl: string;
  name: string;
}

export const driverStatuses = new Set<DeliveryLocationStatus>([
  DeliveryLocationStatus.delivered,
  DeliveryLocationStatus.deliveryFailed,
  DeliveryLocationStatus.driverAssigned,
  DeliveryLocationStatus.onTheWay,
]);

export interface OrderWithAddress {
  id: number;
  runId: number;
  run: {
    store: {
      id: number;
    };
  };
  bagsUsed: number;
  deliveryLocation: {
    id: number;
    onfleetTaskId: string;
    deliveryStatus: DeliveryLocationStatus;
    userAddress: {
      address: string;
    };
    deliveryNote: {
      access: string;
      address: string;
      building: string;
      entrance: string;
      parking: string;
      pikupPoint: string;
    };
  };
}

export interface GetOrdersByIdsInput {
  runId: number;
  orderId: number;
}

export interface GetOrdersByIdsResponse {
  getOrdersByIds: OrderWithAddress[];
}
